module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-button-list"
  }, [(_vm.$slots.primary && _vm.isSave) ? _c('div', {
    staticClass: "__primary"
  }, [_vm._t("primary")], 2) : _vm._e(), _vm._v(" "), (!_vm.$slots.primary && _vm.isSave) ? _c('div', {
    staticClass: "__primary"
  }, [_c('rt-button', {
    attrs: {
      "icon-name": "rt-base-circle-check-lined",
      "color-type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n      " + _vm._s(_vm.primaryName) + "\n    ")])], 1) : _vm._e(), _vm._v(" "), _c('rt-header-button-group', {
    attrs: {
      "max-btns": _vm.maxBtns
    }
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.isBack) ? _c('div', {
    staticClass: "__back"
  }, [_c('rt-button', {
    attrs: {
      "icon-name": "rt-base-back"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$tx('返回', 'xpc.detailheader.back')) + "\n    ")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5dadd811"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/button/rtButtonList.vue
// module id = 2100
// module chunks = 228